import { language } from './index'

const defaultOptions = {

  // 语言
  language: 'zh-CN' as language,

  // 语速
  rate: 1,

  // 语调
  pitch: 1,

  // 音量
  volume: 1
}

export default defaultOptions
